/**
 * Employee Incident List Management Service
 * HTTP operations for the admin-wide incident listing (ASIS-5244)
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type { LC_ListIncidentsManagementIn, LC_ListIncidentsManagementOut, IncidentManagementPage } from '../types';
import { mapIncidentManagementListResponse } from '../mappers';

/**
 * Service for the admin-wide (all employees) incident listing operations
 */
export class EmployeeIncidentListManagementService {
  /**
   * List marking incidents for all employees, with admin filters (ASIS-5244)
   * GET /v{version}/attendances/incidents
   */
  async listManagement(
    params: LC_ListIncidentsManagementIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<IncidentManagementPage>> {
    const queryString = buildQueryString({ ...params });
    const endpoint = `${API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.LIST_MANAGEMENT()}${queryString}`;

    const response = await apiClient.get<LC_ListIncidentsManagementOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapIncidentManagementListResponse(response.data) };
  }
}

export const employeeIncidentListManagementService = new EmployeeIncidentListManagementService();
